import { BrowserRouter, Route, Routes } from "react-router-dom";
import SideBar from "./components/SideBar";
import Login from "./pages/Account/Login";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AuthProvider } from "oidc-react";
import IdleTimeoutWrapper from './hooks/idleTimeoutWrapper';

const oidcConfig = {
    autoSignIn: false,
    authority: process.env.REACT_APP_OIDC_AUTHORITY,
    clientId: process.env.REACT_APP_OIDC_CLIENT_ID,
    redirectUri: process.env.REACT_APP_OIDC_REDIRECT_URI,
    responseType: "code",
    scope: process.env.REACT_APP_OIDC_SCOPE,
    postLogoutRedirectUri: process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI,
};

function App() {
    return (
        <AuthProvider {...oidcConfig}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <BrowserRouter>
                    <IdleTimeoutWrapper>
                        <Routes>
                            <Route exact path="/" element={<Login />} />
                            <Route exact path="/hsse/*" element={<SideBar />} />
                            <Route exact path="/callback" element={<Login isCallback />} />
                        </Routes>
                    </IdleTimeoutWrapper>
                </BrowserRouter>
            </LocalizationProvider>
        </AuthProvider>
    );
}

export default App;
